import { CountBadgeProps } from './CountBadge.types';
import { CountBadgeContainer, CountBadgeDot } from './CountBadge.styles';

const BADGE_OFFSET = 18;
const BADGE_GAP = 2;

export const CountBadge = ({ children, badges }: CountBadgeProps) => {
  const visibleBadges = badges.filter((b) => b.count > 0);

  if (visibleBadges.length === 0) return <>{children}</>;

  return (
    <CountBadgeContainer>
      {children}
      {visibleBadges.map((badge, index) => {
        const rightOffset =
          -BADGE_OFFSET -
          (visibleBadges.length - 1 - index) * (BADGE_OFFSET + BADGE_GAP);

        return (
          <CountBadgeDot
            key={`${badge.color}-${index}`}
            component="span"
            color={badge.color}
            offset={rightOffset}
          >
            {badge.count}
          </CountBadgeDot>
        );
      })}
    </CountBadgeContainer>
  );
};
